import { AxiosInstance } from 'axios';

export interface ClientTicketMessage {
  id: string;
  type: string;
  description: string;
  actionDate?: string;
  createdDate?: string;
  createdBy?: { id: string; name?: string };
  attachments?: Array<{
    id: string;
    fileName: string;
    mimeType?: string;
  }>;
}

export interface ClientTicket {
  id: string;
  title: string;
  stageName?: string;
  lastActionAt?: string;
  messages: ClientTicketMessage[];
}

export default class CrmTicketsServices {
  private axios: AxiosInstance;

  constructor(axios: AxiosInstance) {
    this.axios = axios;
  }

  hasVisibleTickets(companyId?: string): Promise<{
    hasTickets: boolean;
    count: number;
  }> {
    return this.axios.get('/crm-pc/tickets/has-visible', {
      params: companyId ? { companyId } : undefined,
    });
  }

  listTickets(companyId?: string): Promise<ClientTicket[]> {
    return this.axios.get('/crm-pc/tickets', {
      params: companyId ? { companyId } : undefined,
    });
  }

  getTicket(id: string, companyId?: string): Promise<ClientTicket> {
    return this.axios.get(`/crm-pc/tickets/${id}`, {
      params: companyId ? { companyId } : undefined,
    });
  }
}
